import { useContext } from 'react'
import { translate } from '../../../utils/translation'
import { FidelityContext } from '../../../context/FidelityContext'

export const useFilter = () => {
  const { filterStatementsEnums, getCurrentStatementFilter, handleChangeStatementFilter } = useContext(FidelityContext)

  const filterCollection = [
    { key: `statement-filter-${filterStatementsEnums.all}`, value: filterStatementsEnums.all, name: 'Extrato completo' },
    {
      key: `statement-filter-${filterStatementsEnums.accumulation}`,
      value: filterStatementsEnums.accumulation,
      name: 'Apenas acúmulos',
    },
    { key: `statement-filter-${filterStatementsEnums.redemption}`, value: filterStatementsEnums.redemption, name: 'Apenas resgates' },
    { key: `statement-filter-${filterStatementsEnums.expired}`, value: filterStatementsEnums.expired, name: 'Cashback expirados' },
    { key: `statement-filter-${filterStatementsEnums.toReceive}`, value: filterStatementsEnums.toReceive, name: 'Cashback a receber' },
  ]
  const handleFilterRowClick = ({ value }) => {
    handleChangeStatementFilter(value)
  }
  const getActiveFilter = ({ value }) => {
    if (value !== getCurrentStatementFilter()) return false
    return true
  }
  const getTranslate = ({ name }) => {
    return translate(name)
  }
  return { filterCollection, getTranslate, getActiveFilter, handleFilterRowClick }
}
